import { render, staticRenderFns } from "./ConsumptionDetails.vue?vue&type=template&id=4562fad1&scoped=true"
import script from "./ConsumptionDetails.vue?vue&type=script&lang=js"
export * from "./ConsumptionDetails.vue?vue&type=script&lang=js"
import style0 from "./ConsumptionDetails.vue?vue&type=style&index=0&id=4562fad1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4562fad1",
  null
  
)

export default component.exports